<ion-content>
  <div class="modal-content">
    <div class="d-flex pt-20 pb-10 pr-10 pl-10">
      <img src="././assets/icon/backArrow.svg" class="cp" (click)="backBtn()">
      <label class="font_medium fs-16 ml-10 mt-5 black_color">Import</label>
      <label class="font_medium fs-16 ml-10 mt-5 black_color">Competency</label>
    </div>        
  </div>
  
  <div class="table-container">
    <table class="styled-table">
      <thead>
        <tr>
          <th>Sr No</th>
          <th>Date & Time</th>
          <th>Imported By</th>
          <th>Total Imported</th>
          <th>Updated</th>
          <th>Added</th>
          <th>Skipped</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of importHistoryData; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ item.importDate | date: 'dd/MM/yyyy, h:mm a' }}</td>
          <td>{{ item.userId.firstName }} {{ item.userId.lastName }}</td>
          <td>{{ item.totalRecordsCount }}</td>
          <td>{{ item.updatedRecordsCount }}</td>
          <td>{{ item.addedRecordsCount }}</td>
          <td>{{ item.skippedRecordsCount }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ion-content>
